import { machines } from './state.js';
import { authFetch } from './ui.js';
import { esc } from '../lib/tekst.js';
import { toast } from './ui.js';
import { sb } from '../lib/supabase.js';

// ── Batteri QR modal ────────────────────────────────────────
export let batScanStream = null, batScanInterval = null, currentBatMcId = null;

export function openBatModal(mcId) {
  currentBatMcId = mcId;
  document.getElementById('batImeiInput').value = '';
  document.getElementById('batQrModal').classList.add('open');
}

export function closeBatModal() {
  stopBatScan();
  document.getElementById('batQrModal').classList.remove('open');
  currentBatMcId = null;
}

export function extractImeiFromUrl(raw) {
  // Prøv at trække dev_id ud af JDI Cloud URL
  const m = raw.match(/dev_id=(\d{10,20})/);
  if (m) return m[1];
  // Eller hvis det bare er et IMEI direkte (10-20 cifre)
  if (/^\d{10,20}$/.test(raw.trim())) return raw.trim();
  return null;
}

export async function saveBatImei() {
  const raw = document.getElementById('batImeiInput').value.trim();
  const imei = extractImeiFromUrl(raw);
  if (!imei) { toast('❌ Ugyldigt IMEI eller URL — tjek formatet'); return; }
  await storeImei(imei);
}

export async function storeImei(imei) {
  if (!currentBatMcId) return;
  const { error } = await sb.from('machines').update({ battery_imei: imei }).eq('id', currentBatMcId);
  if (error) { toast('❌ Kunne ikke gemme: ' + error.message); return; }
  // Opdater lokalt
  const mc = machines.find(m => m.id === currentBatMcId);
  if (mc) mc.battery_imei = imei;
  closeBatModal();
  toast('✓ Batteritilknytning gemt!');
  // Opdater batterisektionen live
  let batSection = document.querySelector('#mpage-main .bat-section');
  if (!batSection) {
    batSection = document.createElement('div');
    batSection.className = 'bat-section';
    const acts = document.querySelector('#mpage-main .mcacts');
    if (acts) acts.before(batSection);
  }
  batSection.innerHTML = '<div id="mpage-bat-content" class="bat-loading">Henter batteristatus…</div>';
  loadBatteryStatusFull('mpage-bat-content', imei);
  // Opdater knaptekst
  const batBtn = document.querySelector('#mpage-main .bat-qr-btn');
  if (batBtn) batBtn.textContent = '🔋 Skift batteri QR';
  // Opdater mini-widget på forsidekortet
  const miniEl = document.getElementById('bat-mini-' + currentBatMcId);
  if (miniEl) { loadBatteryStatus(currentBatMcId, imei); }
  else {
    const mcCard = document.getElementById('mc-' + currentBatMcId);
    const quickact = mcCard?.querySelector('.mc-quickact');
    if (quickact) {
      const mini = document.createElement('div');
      mini.className = 'mc-bat-mini';
      mini.id = 'bat-mini-' + currentBatMcId;
      mini.innerHTML = '<span style="font-size:11px;color:var(--txt-m)">🔋 Henter…</span>';
      quickact.before(mini);
      loadBatteryStatus(currentBatMcId, imei);
    }
  }
}

export async function startBatScan() {
  if (!('BarcodeDetector' in window)) { toast('📷 QR-scanning understøttes ikke — indsæt URL manuelt'); return; }
  try {
    stopBatScan();
    batScanStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 1280 } } });
    const video = document.getElementById('batQrVideo');
    video.srcObject = batScanStream;
    await video.play();
    document.getElementById('batQrViewfinder').style.display = 'block';
    document.getElementById('batQrScanBtn').style.display = 'none';
    const bd = new BarcodeDetector({ formats: ['qr_code'] });
    const canvas = document.createElement('canvas');
    batScanInterval = setInterval(async () => {
      if (!batScanStream || video.readyState < 2) return;
      canvas.width = video.videoWidth; canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      try {
        const codes = await bd.detect(canvas);
        if (codes.length > 0) {
          const raw = codes[0].rawValue;
          stopBatScan();
          const imei = extractImeiFromUrl(raw);
          if (imei) {
            toast('✓ Batteri QR aflæst!');
            await storeImei(imei);
          } else {
            document.getElementById('batImeiInput').value = raw;
            toast('⚠ Kunne ikke trække IMEI ud — tjek URL');
          }
        }
      } catch(e) {}
    }, 400);
  } catch (err) {
    stopBatScan();
    if (err.name === 'NotAllowedError') toast('❌ Kamera-adgang nægtet');
    else toast('❌ Kamera fejl: ' + err.message);
  }
}

export function stopBatScan() {
  if (batScanInterval) { clearInterval(batScanInterval); batScanInterval = null; }
  if (batScanStream) { batScanStream.getTracks().forEach(t => t.stop()); batScanStream = null; }
  const vf = document.getElementById('batQrViewfinder'); if (vf) vf.style.display = 'none';
  const btn = document.getElementById('batQrScanBtn'); if (btn) btn.style.display = 'block';
}

export const BAT_TYPES = ['elektrisk', 'minigraever', 'minilæsser', 'battery'];

export function isBatteryMachine(m) {
  return BAT_TYPES.includes(m.machine_type) || m._tracker?.machine_type === 'battery' || m._tracker?.machine_type === 'fuel';
}

export function hasFMC130(m) {
  return !!(m._tracker?.imei);
}

export function fltMsg(code, lvl) {
  const msgs = {
    1: 'Overtemperatur — batteri for varmt',
    2: 'Undertemperatur — batteri for koldt',
    3: 'Overtemperatur ved ladning',
    4: 'Overstrøm ved ladning',
    5: 'Overstrøm ved afladning',
    6: 'Overspænding på celle',
    7: 'Underspænding på celle',
    8: 'Overspænding på pakke',
    9: 'Underspænding på pakke',
    14: 'Kortslutning registreret',
    17: 'Lavt batteri — over 20%',
    18: 'Lavt batteri — under 20%',
    19: 'Lavt batteri — under 10%, oplad snart',
    20: 'Kritisk lavt batteri — oplad nu',
    23: 'Kommunikationsfejl',
    24: 'Celleubalance',
  };
  const txt = msgs[parseInt(code)] || 'Fejlkode ' + code;
  const icon = parseInt(lvl) >= 2 ? '⚡' : 'ℹ️';
  return icon + ' ' + txt;
}

export function fmtLastCharged(curr, dt) {
  // curr > 0 = lader lige nu, curr == 0 = standby, curr < 0 = kører
  if (curr > 0) return 'Lader nu';
  return 'Sidst set: ' + dt.toLocaleDateString('da-DK') + ' ' + dt.toLocaleTimeString('da-DK', {hour:'2-digit', minute:'2-digit'});
}

export async function loadFMC130Data(mcId) {
  const m = machines.find(x => x.id === mcId);
  if (!m?._tracker?.imei) return;

  const dataEl   = document.getElementById('fmc-data-' + mcId);
  const statusEl = document.getElementById('fmc-status-' + mcId);
  if (!dataEl) return;

  try {
    // Flespi kaldes via vores egen funktion, som tjekker at enheden
    // tilhører den indloggede bruger, før den udleverer positionen.
    const res = await authFetch(
      '/.netlify/functions/get-tracker-public?imei=' + encodeURIComponent(m._tracker.imei));
    if (!res.ok) throw new Error('Fejl');
    const d = await res.json();
    const t = d.telemetry || {};

    const online = d.online;
    if (statusEl) statusEl.innerHTML = online
      ? '<span style="color:#2ecc71">● Online</span>'
      : '<span style="color:#bbb">○ Offline</span>';

    const items = [
      { label: 'Position', val: t.lat && t.lng ? `<a href="https://maps.google.com/?q=${t.lat},${t.lng}" target="_blank" style="color:var(--green-dk)">📍 Vis på kort</a>` : '–' },
      { label: 'Hastighed', val: t.speed != null ? t.speed + ' km/h' : '–' },
      { label: 'Driftstimer', val: t.engine_hours != null ? t.engine_hours + ' h' : '–' },
      { label: 'Motor RPM', val: t.engine_rpm != null ? t.engine_rpm + ' rpm' : '–' },
      m._tracker.machine_type === 'fuel'
        ? { label: 'Brændstof', val: t.fuel_level != null ? t.fuel_level + '%' : '–' }
        : { label: 'Batteri', val: t.battery_v != null ? t.battery_v + ' V' : '–' },
      { label: 'Spænding', val: t.ext_voltage != null ? t.ext_voltage.toFixed(1) + ' V' : '–' },
    ];

    dataEl.innerHTML = items.map(i => `
      <div style="background:var(--surf2);border:1px solid var(--bdr);border-radius:8px;padding:10px 12px">
        <div style="font-size:10px;text-transform:uppercase;letter-spacing:.5px;color:var(--txt-d);margin-bottom:3px">${i.label}</div>
        <div style="font-size:14px;font-weight:600;color:var(--txt)">${i.val}</div>
      </div>`).join('');

  } catch(e) {
    if (dataEl) dataEl.innerHTML = '<div style="grid-column:span 2;text-align:center;padding:16px;font-size:12px;color:var(--txt-d)">Kunne ikke hente tracker data</div>';
  }
}

// Bemaerk: her laa tidligere en anden loadBatteryStatus, som skrev til
// elementet bat-content-<id>. Det element blev aldrig oprettet, og
// definitionen nedenfor overskrev den alligevel. Detaljevisningen
// haandteres af loadBatteryStatusFull. Den doede kode er fjernet.

// ── Batteri fetch ────────────────────────────────────────────

export async function loadBatteryStatus(mcId, imei) {
  const el = document.getElementById('bat-mini-' + mcId);
  if (!el) return;
  try {
    const res = await fetch('https://wxmp.jdicloud.cn/api/get_dev_rt_data.php?dev_id=' + imei);
    if (!res.ok) throw new Error();
    const json = await res.json();
    if (json.code !== 200) throw new Error();
    const ov = json.data.overview;
    const soc = parseInt(ov.soc) || 0;
    const curr = parseFloat(ov.total_curr) || 0;
    const dt = new Date(ov.dateTime);
    const diffH = Math.round((new Date() - dt) / 3600000);
    const isOnline = diffH < 1;
    const socCls = soc >= 50 ? 'soc-hi' : soc >= 20 ? 'soc-mid' : 'soc-lo';
    const alarm = ov.alarm > 0;
    const idleTxt = diffH < 1 ? null : diffH < 2 ? 'Hvilet 1 time' : diffH < 24 ? 'Hvilet ' + diffH + ' timer' : diffH < 48 ? 'Hvilet siden i går' : 'Hvilet ' + Math.round(diffH/24) + ' dage';
    el.innerHTML =
      '<div class="mc-bat-chip ' + socCls + '">🔋 ' + soc + '%</div>'
      + '<div class="mc-bat-divider"></div>'
      + (idleTxt ? '<div class="mc-bat-chip soc-off">💤 ' + idleTxt + '</div>' : '<div class="mc-bat-chip soc-hi">● Aktiv</div>')
      + (alarm ? '<div class="mc-bat-divider"></div><div class="mc-bat-chip" style="color:var(--orange)">⚠ Alarm</div>' : '');
  } catch(e) {
    el.innerHTML = '<span style="font-size:11px;color:var(--txt-m)">🔋 Status utilgængelig</span>';
  }
}

export async function loadBatteryStatusFull(elId, imei) {
  const el = document.getElementById(elId);
  if (!el) return;
  try {
    // Hent realtidsdata og run log parallelt
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const [rtRes, logRes] = await Promise.all([
      fetch('https://wxmp.jdicloud.cn/api/get_dev_rt_data.php?dev_id=' + imei),
      fetch(`https://wxmp.jdicloud.cn/api/get_dev_run_log.php?dev_id=${imei}&year=${year}&month=${month}&diff_time=60`)
    ]);
    if (!rtRes.ok) throw new Error('HTTP ' + rtRes.status);
    const rtJson = await rtRes.json();
    if (rtJson.code !== 200) throw new Error(rtJson.msg || 'Fejl');

    const ov = rtJson.data.overview;
    const soc = parseInt(ov.soc) || 0;
    const volt = parseFloat(ov.total_volt) || 0;
    const curr = parseFloat(ov.total_curr) || 0;
    const ct = rtJson.data.ct_data;
    const tempAvg = ct ? ct.avg : null;
    const dt = new Date(ov.dateTime);
    const diffH = Math.round((new Date() - dt) / 3600000);
    const isOnline = diffH < 1;
    const idleTxt = diffH < 1 ? null : diffH < 2 ? 'Hvilet 1 time' : diffH < 24 ? 'Hvilet ' + diffH + ' timer' : diffH < 48 ? 'Hvilet siden i går' : 'Hvilet ' + Math.round(diffH/24) + ' dage';
    const socClass = soc >= 50 ? 'hi' : soc >= 20 ? 'mid' : 'lo';
    const alarm = ov.alarm > 0;
    const flt = ov.flt_info?.length ? ov.flt_info[0] : null;

    // Run log data
    let runHtml = '';
    if (logRes.ok) {
      const logJson = await logRes.json();
      if (logJson.code === 200) {
        const logOv = logJson.data.overview;
        const dayLog = logJson.data.day_log || [];

        // Find sidst ladet: seneste session hvor SOC steg
        const lastCharge = dayLog.find(d => parseFloat(d.socEnd) > parseFloat(d.socStart));
        const lastRun = dayLog.find(d => parseFloat(d.socEnd) < parseFloat(d.socStart));

        const fmtMin = (min) => {
          if (min < 60) return Math.round(min) + ' min';
          return (min / 60).toFixed(1) + ' t';
        };

        const totalH = parseFloat(logOv.total_run_time) || 0;

        // Service intervals for El-minilæsser
        // Baseret på service skema fra DK·TEC
        const svcIntervals = [
          { label: 'Batteri kontrol',           every: 10,   first50: true },
          { label: 'Hjulbolte efterspændes',    every: 10,   first50: true },
          { label: 'Smøring',                   every: 10,   first50: true },
          { label: 'Akselolie skift',           every: 500,  first50: true },
          { label: 'Hydraulik filter',          every: 2000, yearly: true  },
          { label: 'Hydraulik olie',            every: 2000, yearly: true  },
        ];

        // Beregn hvilke serviceinterval der er passeret
        const svcDue = [];
        for (const s of svcIntervals) {
          if (s.first50 && totalH < 50) {
            svcDue.push({ label: s.label, note: 'Første 50 timer — ' + Math.round(50 - totalH) + ' timer tilbage', urgent: totalH >= 45 });
            continue;
          }
          if (s.every) {
            const nextAt = Math.ceil(totalH / s.every) * s.every;
            const tillNext = nextAt - totalH;
            const warnAt = s.every <= 10 ? 2 : s.every <= 500 ? 20 : 50; // timer før advarsel
            if (tillNext <= warnAt) {
              svcDue.push({ label: s.label, note: tillNext <= 0 ? 'Forfalden nu!' : 'Om ca. ' + Math.round(tillNext) + ' timer (ved ' + nextAt + ' t)', urgent: tillNext <= warnAt / 2 });
            }
          }
        }

        const svcHtml = svcDue.length > 0 ? `
          <div style="margin-top:10px;padding:10px 12px;background:rgba(184,106,32,.08);border:1px solid rgba(184,106,32,.3);border-radius:8px">
            <div style="font-family:'Oswald',sans-serif;font-size:11px;letter-spacing:1.5px;text-transform:uppercase;color:var(--orange);margin-bottom:8px">⚙ Service nærmer sig</div>
            ${svcDue.map(s => `
              <div style="display:flex;align-items:flex-start;gap:8px;margin-bottom:6px;font-size:12px">
                <span style="color:${s.urgent ? 'var(--orange)' : 'var(--txt-d)'};margin-top:1px">${s.urgent ? '●' : '○'}</span>
                <div>
                  <div style="font-weight:500;color:var(--txt)">${s.label}</div>
                  <div style="color:var(--txt-m);font-size:11px">${esc(s.note)}</div>
                </div>
              </div>`).join('')}
            <a href="https://www.dk-tec.dk/book-service" target="_blank" rel="noopener"
               style="display:block;margin-top:8px;padding:8px;background:var(--orange);color:#fff;border-radius:6px;font-family:'Oswald',sans-serif;font-size:11px;letter-spacing:1px;text-transform:uppercase;text-align:center;text-decoration:none">
              📅 Book service hos DK·TEC
            </a>
          </div>` : '';

        // Fuldt serviceskema som fold-ud tabel
        const schemaHtml = `
          <div style="margin-top:10px">
            <button onclick="this.nextElementSibling.style.display=this.nextElementSibling.style.display==='none'?'block':'none';this.textContent=this.textContent.includes('Vis')?'▲ Skjul serviceskema':'▼ Vis serviceskema'"
              style="width:100%;padding:8px 12px;background:var(--surf2);border:1px solid var(--bdr2);border-radius:6px;font-family:'Oswald',sans-serif;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--txt-d);cursor:pointer;text-align:left;transition:all .15s">
              ▼ Vis serviceskema
            </button>
            <div style="display:none;margin-top:8px;border:1px solid var(--bdr);border-radius:8px;overflow:hidden;font-size:12px">
              <div style="background:var(--anth);color:#fff;padding:8px 12px;font-family:'Oswald',sans-serif;font-size:11px;letter-spacing:1.5px;text-transform:uppercase">
                Service af El-minilæsser
              </div>
              <table style="width:100%;border-collapse:collapse">
                <thead>
                  <tr style="background:var(--surf2);font-family:'Oswald',sans-serif;font-size:10px;letter-spacing:.5px;text-transform:uppercase;color:var(--txt-m)">
                    <th style="padding:7px 10px;text-align:left;border-bottom:1px solid var(--bdr)">Punkt</th>
                    <th style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr)">Første 50t</th>
                    <th style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr)">Hver 10t</th>
                    <th style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr)">Hver 500t</th>
                    <th style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr)">Hver 2000t</th>
                    <th style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr)">Årligt</th>
                  </tr>
                </thead>
                <tbody>
                  ${[
                    ['Hydraulik olie',         false, false, false, true,  true ],
                    ['Hydraulik filter',       false, false, false, true,  true ],
                    ['Akselolie',              true,  false, true,  false, false],
                    ['Smøring',                true,  true,  false, false, false],
                    ['Hjulbolte efterspændes', true,  true,  false, false, false],
                    ['Batteri',                true,  true,  false, false, true ],
                    ['Bremser kontrol',        false, false, false, false, true ],
                  ].map((row, i) => {
                    const [name, ...checks] = row;
                    const bg = i % 2 === 0 ? 'background:var(--surf)' : 'background:var(--surf2)';
                    const cells = checks.map(v => `<td style="padding:7px 6px;text-align:center;border-bottom:1px solid var(--bdr);color:var(--green-dk)">${v ? '✓' : ''}</td>`).join('');
                    return `<tr style="${bg}"><td style="padding:7px 10px;border-bottom:1px solid var(--bdr);color:var(--txt)">${name}</td>${cells}</tr>`;
                  }).join('')}
                </tbody>
              </table>
              <div style="padding:8px 10px;font-size:11px;color:var(--txt-m);background:var(--surf2);border-top:1px solid var(--bdr)">
                Oliekift skal foretages indenfor det første år for at undgå garantibortfald.
              </div>
            </div>
          </div>`;

        runHtml = `
        <div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--bdr)">
          <div class="bat-title" style="margin-bottom:8px">🔌 Opladning</div>
          <div class="bat-stats">
            <div class="bat-stat">
              <div class="bat-stat-lbl">I alt</div>
              <div class="bat-stat-val">${parseFloat(logOv.total_chg_time).toFixed(0)} t</div>
            </div>
            <div class="bat-stat">
              <div class="bat-stat-lbl">Denne måned</div>
              <div class="bat-stat-val">${logOv.month_sel_chg_time} t</div>
            </div>
            <div class="bat-stat">
              <div class="bat-stat-lbl">Sidst ladet</div>
              <div class="bat-stat-val" style="font-size:11px">${lastCharge ? month + '/' + lastCharge.day.split(' ')[0] + ' · ' + lastCharge.socStart + '→' + lastCharge.socEnd + '%' : '—'}</div>
            </div>
          </div>
          ${svcHtml}
          ${schemaHtml}
        </div>`;
      }
    }

    el.innerHTML = `
      <div class="bat-header">
        <div class="bat-title">🔋 Batteristatus</div>
        <div class="bat-status ${isOnline ? 'bat-online' : 'bat-offline'}">${isOnline ? '● Aktiv nu' : (idleTxt || 'Hvilet')}</div>
      </div>
      ${alarm && flt ? `<div class="bat-alarm" style="margin-bottom:8px">${fltMsg(flt.code, flt.lvl)}</div>` : ''}
      <div class="soc-wrap">
        <div class="soc-bar-bg"><div class="soc-fill ${socClass}" style="width:${soc}%"></div></div>
        <div class="soc-pct">${soc}%</div>
      </div>
      <div class="bat-stats">
        <div class="bat-stat"><div class="bat-stat-lbl">Spænding</div><div class="bat-stat-val">${volt} V</div></div>
        <div class="bat-stat"><div class="bat-stat-lbl">Strøm</div><div class="bat-stat-val">${curr} A</div></div>
        ${tempAvg !== null ? `<div class="bat-stat"><div class="bat-stat-lbl">Temperatur</div><div class="bat-stat-val">${tempAvg} °C</div></div>` : `<div class="bat-stat"><div class="bat-stat-lbl">Status</div><div class="bat-stat-val" style="font-size:11px">${isOnline ? '● Aktiv' : (idleTxt || 'Hvilet')}</div></div>`}
      </div>
      ${ov.lb ? `<a class="bat-loc" href="https://maps.google.com/?q=${ov.lb.latitude.toFixed(6)},${ov.lb.longitude.toFixed(6)}" target="_blank" rel="noopener" style="text-decoration:none;display:flex;align-items:center;justify-content:space-between;padding:8px 10px;background:var(--surf2);border:1px solid var(--bdr);border-radius:6px;margin-bottom:4px"><span style="color:var(--txt-d)">📍 ${ov.lb.latitude.toFixed(4)}°N, ${ov.lb.longitude.toFixed(4)}°E</span><span style="font-family:'Oswald',sans-serif;font-size:10px;letter-spacing:1px;text-transform:uppercase;color:var(--green-dk)">Åbn kort ↗</span></a>` : ''}
      <div class="bat-ts">${fmtLastCharged(curr, dt)}</div>
      ${runHtml}
      <a class="bat-open-btn" href="https://www.jdicloud.cn/device/single_dev.html?dev_id=${imei}" target="_blank" rel="noopener">Se fuld batterioversigt →</a>`;
  } catch(e) {
    el.innerHTML = `<div class="bat-loading">Kunne ikke hente batteristatus · <a href="https://www.jdicloud.cn/device/single_dev.html?dev_id=${imei}" target="_blank" rel="noopener" style="color:var(--green-dk)">Åbn JDI Cloud →</a></div>`;
  }
}

export async function toggleBatteryType(mcId, on) {
  const newType = on ? 'elektrisk' : 'standard';
  const { error } = await sb.from('machines').update({ machine_type: newType }).eq('id', mcId);
  if (error) {
    toast('❌ Kunne ikke gemme');
    const tog = document.getElementById('bat-tog-' + mcId);
    if (tog) tog.checked = !on;
    return;
  }
  const mc = machines.find(m => m.id === mcId);
  if (mc) mc.machine_type = newType;
  toast(on ? '⚡ Batterimaskine aktiveret' : 'Batterimaskine slået fra');

  const acts = document.querySelector('#mpage-main .mcacts');
  const existing = document.querySelector('#mpage-main .bat-section');
  if (on) {
    if (!existing && acts) {
      const div = document.createElement('div');
      div.className = 'bat-section';
      if (mc && mc.battery_imei) {
        div.innerHTML = '<div id="mpage-bat-content" class="bat-loading">Henter batteristatus…</div>';
        acts.before(div);
        loadBatteryStatusFull('mpage-bat-content', mc.battery_imei);
      } else {
        div.innerHTML = '<div class="bat-header"><div class="bat-title">🔋 Batteristatus</div></div><button class="bat-add-btn" onclick="openBatModal(\'' + mcId + '\')">📷 Scan batteri QR-kode for at aktivere batteriovervågning</button>';
        acts.before(div);
      }
    }
    if (acts && !acts.querySelector('.bat-qr-btn')) {
      const btn = document.createElement('button');
      btn.className = 'bxs bat-qr-btn';
      btn.textContent = mc?.battery_imei ? '🔋 Skift batteri QR' : '🔋 Tilknyt batteri';
      btn.onclick = () => openBatModal(mcId);
      acts.insertBefore(btn, acts.querySelector('.bxs.del'));
    }
    if (mc && !mc.battery_imei) openBatModal(mcId);
  } else {
    if (existing) existing.remove();
    const batBtn = acts?.querySelector('.bat-qr-btn');
    if (batBtn) batBtn.remove();
    const miniEl = document.getElementById('bat-mini-' + mcId);
    if (miniEl) miniEl.remove();
  }
}
